import APIService from "./API.service";
const queryString = require("query-string");

class AccountService extends APIService {
  // Get list of accounts
  getAccounts(search: string = '', start: number = 0) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
      search,
      start,
    };

    return this.call.get(`${this.apiUrl}/accounts?${queryString.stringify(query)}`);
  }

  // Update account
  updateAccount(accountId: number, data: {id?: number, image?: string, name?: string}) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };
    return this.call.put(
      `${this.apiUrl}/accounts/${accountId}?${queryString.stringify(query)}`,
      JSON.stringify(data)
    );
  }

  // Create account
  createAccount(data: {name: string}) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };
    return this.call.post(
      `${this.apiUrl}/accounts?${queryString.stringify(query)}`,
      JSON.stringify(data)
    );
  }

  deleteAccount(accountId: number) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };
    return this.call.delete(
      `${this.apiUrl}/accounts/${accountId}?${queryString.stringify(query)}`
    );
  }

  getAccountsUsers(accountId:number){
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };
    return this.call.get(
      `${this.apiUrl}/accounts/${accountId}/users?${queryString.stringify(query)}`
    );
  }
}

export default AccountService;
